import { Component, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, AgentTrendGPTService, ConfirmationComponent } from 'lib-trend-core';
import { firstValueFrom } from 'rxjs';
import { ChannelRef } from '../agent-trendgpt-form/agent-trendgpt-form.component';
import { IntentionModalComponent, IntentionModalData, IntentionModalResult } from './intention-modal/intention-modal.component';
@Component({
    selector: 'app-agent-intentions-form',
    templateUrl: './agent-intentions-form.component.html',
    styleUrl: './agent-intentions-form.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgentIntentionsFormComponent extends AbstractComponent {
  @Input() agentId: string;
  @Input() channelRef: Array<ChannelRef> = [];

  intentions: Array<any> = [];

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    private agentTrendGPTService: AgentTrendGPTService,
  ) {
    super(injector);
  }

  async ngOnInit(): Promise<void> {
    await this.getIntentionsByAgentId();
  }

  private async getIntentionsByAgentId(): Promise<void> {
    this.intentions = [];
    this.loadingContent = true;

    try {
      const response = await firstValueFrom(this.agentTrendGPTService.getIntentionsByAgentId(this.agentId, { page: 1, pageSize: 100 }));

      if (response && typeof response === 'object' && 'data' in response) {
        this.intentions = (response as any).data ?? [];
      } else if (Array.isArray(response)) {
        this.intentions = response;
      } else {
        this.intentions = [];
      }
    } catch (error) {
      this.alertService.error(this.t('agents.intentionsForm.loadError'));
    } finally {
      this.loadingContent = false;
    }
  }

  async delete(intentionId: string): Promise<void> {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const retorno = await firstValueFrom(this.agentTrendGPTService.deleteIntentionById(intentionId));
            this.alertService.success(this.t('agents.intentionsForm.deleteSuccess'));
            await this.getIntentionsByAgentId();
            return;
        } catch (error) {
          this.alertService.error(this.t('agents.intentionsForm.deleteError'));
        }
      }
    });
  }

  openModal(intention?: any): void {
    const data: IntentionModalData = {
      agentId: this.agentId,
      channelRef: this.channelRef,
      editMode: !!intention,
      intention: intention
    };

    const dialogRef = this.dialog.open(IntentionModalComponent, {
      width: '900px',
      data: data
    });

    dialogRef.afterClosed().subscribe((result: IntentionModalResult) => {
      if (result?.success) {
        this.getIntentionsByAgentId();
      }
    });
  }

  startEdit(intention: any): void {
    this.openModal(intention);
  }
}
